import { TextNodeType } from "@tm/isomorphic-utils";
import FormattedText from "../../FormattedText/FormattedText";
import {
  BackButton,
  HeadingPersuasionWrapper,
  HeroTitle,
  HeroTitleBlock,
  PromoStrip,
} from "../Styles";
import { HeadingPersuasion } from "./HeadingPersuasion";

interface HeroBarProps {
  title?: TextNodeType;
  headingPersuasion?: { stats?: TextNodeType; icon?: string };
  promoText?: TextNodeType;
  hasHeadingPersuasion: boolean;
  /** Sticky duplicate bar: keep one real `<h1>` on the page (main hero only). */
  titleAsDiv?: boolean;
}

/**
 * Reusable hero title + persuasion/promo strip used in both the
 * static hero and the scroll-locked sticky header.
 */
export const HeroBar = ({
  title,
  headingPersuasion,
  promoText,
  hasHeadingPersuasion,
  titleAsDiv = false,
}: HeroBarProps) => (
  <>
    <HeroTitleBlock>
      <BackButton onClick={() => window.history.back()} aria-label="Go back" />
      <HeroTitle as={titleAsDiv ? "div" : "h1"}>
        <FormattedText value={title || "Insurance & protection plans"} />
      </HeroTitle>
    </HeroTitleBlock>
    {hasHeadingPersuasion ? (
      <HeadingPersuasionWrapper>
        <HeadingPersuasion headingPersuasion={headingPersuasion} />
      </HeadingPersuasionWrapper>
    ) : promoText ? (
      <PromoStrip>
        <FormattedText value={promoText} />
      </PromoStrip>
    ) : null}
  </>
);
